export default {
  changeLogin(state, data) {
    state.isLogin = data;
    try {
      localStorage.isLogin = data;
    } catch (e) {
      throw new Error(e);
    }
  },
  setLoginInfo(state, loginInfo) {
    state.loginInfo = loginInfo;
    try {
      localStorage.loginInfo = JSON.stringify(loginInfo);
    } catch (e) {
      throw new Error(e);
    }
  },
  setIntegralAll(state,integralAll) {
    state.integralAll = integralAll;
    try {
      localStorage.integralAll = JSON.stringify(integralAll);
    } catch (e) {
      throw new Error(e);
    }
  },
  setStepAll(state,stepAll) {
    state.stepAll = stepAll;
    try {
      localStorage.stepAll = JSON.stringify(stepAll);
    } catch (e) {
      throw new Error(e);
    }
  }
};
